import React from "react"
import { Entity, User } from "models"

export type UserAction =
	| { type: "LOGIN"; entity: Entity }
	| { type: "USER"; user: User }
	| { type: "LOGOUT" }
export type UserDispatch = (action: UserAction) => void

type UserContextInterface = {
	entity: Entity // account entity data (region, token, ...)
	user: User // user data (description, operator, ...)
	dispatch: React.Dispatch<UserAction>
}

const UserContext = React.createContext<UserContextInterface | undefined>(undefined)

const userReducer = ({ user, entity }: { user: User; entity: Entity }, action: UserAction) => {
	switch (action.type) {
		case "LOGIN": {
			return {
				user,
				entity: action?.entity || entity,
			}
		}
		case "USER": {
			return {
				entity,
				user: action?.user || user,
			}
		}
		case "LOGOUT": {
			return {
				entity: null,
				user: null,
			}
		}
	}
}

const UserProvider = ({ children }: { children: React.ReactNode }) => {
	const [{ entity, user }, dispatch] = React.useReducer(userReducer, {
		entity: null,
		user: null,
	})
	return (
		<UserContext.Provider value={{ entity, user, dispatch }}>{children}</UserContext.Provider>
	)
}

const useUser = () => {
	const context = React.useContext(UserContext)
	if (context === undefined) {
		throw new Error("useUser must be used within a UserProvider")
	}
	return context
}

export { useUser, UserProvider }
